/**
 * Home Slider Demo 2
 */
import React, { Component } from "react";
import Slider from "react-slick";

const settings = {
  dots: false,
  infinite: true,
  speed: 500,
  arrows: true,
  slidesToShow: 1,
  slidesToScroll: 1
};

class HomSlider2 extends Component {
  render() {
    return (
      <>
        {/* PAGE LEVEL CSS */}
        <style>{`
          html, body {
            height: 100%;
            margin: 0;
          }

          /* slick wrapper height fix */
          .slider-02,
          .slider-02 .slick-slider,
          .slider-02 .slick-list,
          .slider-02 .slick-track {
            height: 100vh;
          }

          .slider-02 .slick-slide > div {
            height: 100vh;
          }

          /* slide structure */
          .slide-02-item,
          .slide-inner,
          .slide-image {
            width: 100%;
            height: 100vh;
          }

          /* image full screen */
          .slide-image img {
            width: 100%;
            height: 100%;
            object-fit: cover;
            display: block;
          }

          /* optional: reduce height on mobile */
          @media (max-width: 768px) {
            .slide-02-item,
            .slide-inner,
            .slide-image {
              height: 80vh;
            }
          }
        `}</style>

        {/* SLIDER */}
        <Slider className="slider-02 slider-simple-arrow" {...settings}>
          <div className="slide-02-item">
            <div className="slide-inner">
              <div className="slide-image">
                <img
                  src={require("../assets/images/houseOfSeroBanner.png")}
                  alt="slide-1"
                />
              </div>
            </div>
          </div>
        </Slider>
      </>
    );
  }
}

export default HomSlider2;
